import React from "react";

const palette = ["#2E6FAA", "#0F766E", "#B8975C", "#7C3AED", "#0369A1", "#9D174D", "#0891B2"];

export const Avatar = ({ name = "", src = "", size = 40, testId, ring = false }) => {
  const dimension = { width: size, height: size };
  const initials = (name || "?")
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const color = palette[(name.charCodeAt(0) || 0) % palette.length];
  const ringCls = ring ? "ring-2 ring-seafoam ring-offset-2 ring-offset-background" : "";

  if (src) {
    return (
      <img
        data-testid={testId}
        src={src}
        alt={name}
        style={{ ...dimension, objectFit: "cover" }}
        className={`rounded-full border border-border shrink-0 ${ringCls}`}
      />
    );
  }
  return (
    <div
      data-testid={testId}
      style={{ ...dimension, backgroundColor: color, fontSize: size * 0.4 }}
      className={`rounded-full flex items-center justify-center text-white font-semibold shrink-0 select-none ${ringCls}`}
    >
      {initials}
    </div>
  );
};
